import React from "react";
import { connect } from "react-redux";

import { Game } from "../models/Game";
import { SearchService } from "../services/Search";
import { SearchTemplate } from "../templates/Search/Search";
import { BadgeService } from "../services/BadgeService";
import { RouteComponentProps } from "react-router-dom";

type SearchPageProps = {
  games: Game[];
  term: string;
  location: any;
  allGames: Game[];
};

interface RootState {
  games: Game[];
  router: any;
  allGames: Game[];
}

class Page extends React.PureComponent<SearchPageProps> {
  static displayName = "Page";

  componentDidMount() {
    BadgeService.updateBadgeStatus();
  }

  render() {
    const { games, term, allGames } = this.props;
    const notHiddenGames = games.filter((game) => game.seo_IsHidden !== true);

    return (
      <SearchTemplate
        caption={`Results for '${term}'`}
        games={notHiddenGames}
        allGames={allGames}
        term={term}
      />
    );
  }
}

export const Search = connect(
  (state: RootState, props: RouteComponentProps<any>) => ({
    games: SearchService.searchGames(state.games, props.match.params.game),
    term: props.match.params.game,
    location: state.router.location,
    allGames: state.games,
  })
)(Page);

Search.displayName = "SearchPage";
